import { Input } from 'antd';
import React from 'react';
import { CascaderInput, DatePickerInput, HiddenInput, NumberInput, SelectInput, SwitchInput, TextInput, TimePickerInput, UploadPictureInput } from './items/BaseInputItem';
import FormItem from './items/FormItem';

enum INPUT_TYPE {
    TEXT = 'string',
    NUMBER = 'number',
    CURRENCY = 'currency',
    LOGO = 'logo',
    PASSWORD = 'password',
    PERCENT = 'percent',
    SELECT = 'select',
    CASCADER = 'cascader',
    DATETIME = 'datetime',
    DATE = 'date',
    TIME = 'time',
    CHECKBOX = 'checkbox',
    RADIO = 'radio',
    FORM = 'form',
    HIDDEN = 'hidden',
    LOCKED = 'locked',
    SWITCH = 'switch',
    FILE_PICKER = 'file',
    EMR_FIELD = 'emr-field',
    SUB_FORM = "sub-form",
    EMR_FULL = "emr-full",
    EMR_CUSTOM = "emr-custom"
}

enum VIEW_TYPE {
    LABEL = "label",
    HTML = "html",
    INPUT_TEXT = "input_text",
    RAW_TEXT = "rawtext",
    ATTACHED_FILE = "file",
    IMAGE = "image",
    RADIO = "radio",
    CHECK = "check",
    EMR_FIELD = "emr-field",
    SUB_FORM = "sub-form",
    EMR_FULL = "emr-full",
    EMR_CUSTOM = "emr-custom"
}

enum DATA_TYPE {
    EMR = "emr",
    STRING = "string",
    NUMBER = "number",
    BOOLEAN = "boolean",
    OBJECT = "object",
    ARRAY = "array",
    IMAGE = "image",
    FILE = "file",
    DATETIME = "date"
}

export interface IInputField {
    key: string;
    value: any; //Or object
    defaultValue?: any; //Or object
    label?: string;
    props?: any;
    dataType?: DATA_TYPE;
    inputType?: INPUT_TYPE;
    viewType?: VIEW_TYPE;
    isHidden?: boolean;
    editable?: boolean;
    required?: boolean;
    group?: string;
    extra?: any;
    isSubField?: boolean;
    onDataChanged?: (fieldKey: string[] | string, value: any) => void;
    name?: string[] | string;
    fieldKey?: string[] | string;
}

class InputField {
    key = '';
    originValue = ''; //Or object
    label = '';
    props: any = {};
    dataType = DATA_TYPE.STRING;
    inputType = INPUT_TYPE.TEXT;
    viewType = VIEW_TYPE.INPUT_TEXT;
    isHidden = false;
    editable = true;
    required = false;
    group = '';
    extra: any = {};
    isSubField = false;
    onDataChanged?: (fieldKey: string[] | string, value: any) => void;
    name?: string[] | string;
    fieldKey?: string[] | string;

    constructor(data: IInputField) {
        this.key = data.key;
        this.name = data.name;
        this.originValue = (data.value!=undefined && data.value!=null) ? data.value : undefined;
        this.required = data.required ? data.required : false;
        this.isHidden = data.isHidden ? data.isHidden : false;
        this.editable = data.editable ? data.editable : true;
        this.group = data.group ? data.group : '';
        this.extra = data.extra;
        // console.log("======= PROPS: ", data.extra)
        this.props = data && data.extra && data.extra.props ? { ...data.extra.props } : {};
        if (data && data.defaultValue)
            this.addProp('defaultValue', data.defaultValue);
        if(!this.editable)
            this.addProp('disabled', true)

        this.inputType = data && data.inputType ? data.inputType : INPUT_TYPE.TEXT;
        this.dataType = data && data.dataType ? data.dataType : DATA_TYPE.STRING;
        this.viewType = data && data.viewType ? data.viewType : VIEW_TYPE.INPUT_TEXT;
        this.label = data && data.label ? data.label : data.key;

        if (data.value!=undefined && data.value!=null) {
            if (typeof data.value === 'boolean')
                this.inputType = INPUT_TYPE.SWITCH;
            else if (
                typeof data.value === 'number' ||
                typeof data.value === 'bigint'
            ) {
                // console.log("VALUE: ", this);
                this.inputType = INPUT_TYPE.NUMBER;
            } else if (Array.isArray(data.value)) {
                this.inputType = INPUT_TYPE.CASCADER;
            } else if (typeof data.value === 'object') {
                this.inputType = INPUT_TYPE.SUB_FORM;
                // this.value = createInput(data.value, this);
            }
        }

        if (data.dataType === DATA_TYPE.EMR) {
            console.log("EMR_FULL EXTRA DATA 1 ========: ", data.extra)
            console.log("EMR_FULL EXTRA DATA 2 ========: ", data)
            if (data.viewType === VIEW_TYPE.SUB_FORM || data.inputType === INPUT_TYPE.SUB_FORM) {
                console.log("SUBFORM EXTRA DATA ========: ", data.extra)
                this.inputType = INPUT_TYPE.SUB_FORM
            }
            if (data.viewType === VIEW_TYPE.EMR_FULL || data.inputType === INPUT_TYPE.EMR_FULL) {
                console.log("EMR_FULL EXTRA DATA ========: ", data.extra)
                this.inputType = INPUT_TYPE.EMR_FULL
            }
            if (data.viewType === VIEW_TYPE.EMR_CUSTOM || data.inputType === INPUT_TYPE.EMR_CUSTOM) {
                console.log("EMR_CUSTOM EXTRA DATA ========: ", data.extra)
                this.inputType = INPUT_TYPE.EMR_CUSTOM
            }
        }
    }

    addProp = (key: string, value: any) => {
        if (!this.props) this.props = {};
        if (key) this.props[key] = value;
    };

    setProps = (props: any) => {
        this.props = props;
    };

    convertToSelect = (options: Array<any>) => {
        this.addProp('options', options);
        this.inputType = INPUT_TYPE.SELECT;
    };
    convertToMultiSelect = (options: Array<any>) => {
        this.addProp('options', options);
        this.addProp('mode', 'tags');
        this.inputType = INPUT_TYPE.SELECT;
    };
    convertToCascader = (options: Array<any>) => {
        this.addProp('options', options);
        this.inputType = INPUT_TYPE.CASCADER;
    };
    convertToLazyCascader = (options: Array<any>, loadDataEvent: any) => {
        this.addProp('options', options);
        this.addProp('loadData', loadDataEvent);
        this.inputType = INPUT_TYPE.CASCADER;
    };
    convertToCurrency = (currencyType: any) => {
        this.addProp('currencyType', currencyType);
        this.inputType = INPUT_TYPE.CURRENCY;
    };
    generateUI = () => {
        if (this.onDataChanged)
            this.addProp('onDataChanged', this.onDataChanged)
        if (this.extra && this.extra.inputStyle)
            this.addProp('inputStyle', this.extra.inputStyle)
        this.addProp('fieldKey', this.fieldKey ? this.fieldKey : this.key)

        let fieldInput = null;
        if (!this.inputType) this.inputType = INPUT_TYPE.TEXT;
        // console.log('Input EMR field: ', this.props);
        switch (this.inputType) {
            case INPUT_TYPE.HIDDEN:
                fieldInput = HiddenInput(this.props);
                this.isHidden = true
                break;
            // case INPUT_TYPE.LOCKED:
            //     fieldInput = TextInput({ ...this.props, disabled: true });
            //     break;
            // case INPUT_TYPE.EMR_FIELD:
            //     fieldInput = emrFieldInput(standardProps);
            //     break;
            case INPUT_TYPE.SUB_FORM:
                // console.log('Input EMR Item: ', inputItem);
                // fieldInput = emrSubFormInput(inputItem);
                break;
            case INPUT_TYPE.EMR_FULL:
                // console.log('Input EMR Item with full View: ', inputItem);
                // fieldInput = emrFullInput(inputItem);
                break;
            case INPUT_TYPE.EMR_CUSTOM:
                // console.log('Input EMR Item CUSTOM: ', inputItem);
                // fieldInput = emrCustomInput(inputItem);
                break;
            case INPUT_TYPE.NUMBER:
                fieldInput = NumberInput(this.props);
                break;
            case INPUT_TYPE.SELECT:
                fieldInput = SelectInput(this.props );
                break;
            case INPUT_TYPE.CASCADER:
                fieldInput = CascaderInput(this.props);
                break;
            case INPUT_TYPE.LOGO:
                fieldInput = UploadPictureInput(this.props);
                break;
            case INPUT_TYPE.RADIO:
                // fieldInput = radioInput(standardProps);
                break;
            case INPUT_TYPE.DATETIME:
                fieldInput = DatePickerInput({ ...this.props, showTime: true })
                break;
            case INPUT_TYPE.DATE:
                fieldInput = DatePickerInput(this.props)
                break;
            case INPUT_TYPE.TIME:
                fieldInput = TimePickerInput(this.props)
                break;
            case INPUT_TYPE.SWITCH:
                fieldInput = SwitchInput({...this.props, defaultChecked: this.originValue});
                break;
            default:
                fieldInput = TextInput(this.props);
                break;
        }
        // console.log("Input Field render ========: ", standardProps);
        return <FormItem item={this} isSubItem={this.isSubField} key={this.key}>{fieldInput}</FormItem>;
    }
}

export { INPUT_TYPE, InputField };
